import React, { useEffect } from "react"
import { trans } from "../../../_providers/Translation"
import ReactTooltip from "react-tooltip"

function Product(props) {
  const handlePrint = (id) => {
    let img = document.querySelector('img[data-for="' + id + '"]')

    if (img) {
      let src = img.getAttribute("src")

      let w = window.open("", "_blank")

      w.document.write('<img src="' + src + '" />')
      w.document.close()

      w.focus()
      w.print()
    }
  }

  return (
    <table>
      <thead>
        <tr>
          <th>{trans("tables.activity")}</th>
          <th>{trans("tables.date")}</th>
          <th>{trans("tables.employee")}</th>
          <th>{trans("tables.category")}</th>
          <th>{trans("tables.name")}</th>
          <th>{trans("tables.description")}</th>
          <th className="right">{trans("tables.price")}</th>
          <th>{trans("tables.brand")}</th>
          <th>{trans("tables.model")}</th>
          <th>{trans("tables.number")}</th>
          <th className="center">{trans("tables.qrCode")}</th>
        </tr>
      </thead>
      <tbody>
        {props.data.map((h, i) => (
          <tr
            key={i}
            className={[h.actual ? "actual" : h.selected ? "selected" : ""]}
          >
            <td>{h.event}</td>
            <td>{h.date}</td>
            <td>{h.causer && `${h.causer.name} ${h.causer.lastname}`}</td>
            <td>{h.subject.category ? h.subject.category.name : "-"}</td>
            <td>{h.subject ? h.subject.name : "-"}</td>
            <td>{h.subject ? h.subject.description : "-"}</td>
            <td className="right">
              {h.subject
                ? `${(Number(h.subject?.sell_price) || 0).toFixed(2)} ${h.subject.currency_name || ''}`
                : "-"}
            </td>
            <td>{h.subject ? h.subject.brand : "-"}</td>
            <td>{h.subject ? h.subject.model : "-"}</td>
            <td>{h.subject ? h.subject.number : "-"}</td>
            <td className="center">
              <img
                src={h.subject.qrcode_url}
                data-tip
                data-for={"qr-" + h.subject.id}
                alt=""
                height={25}
                width={25}
              />
              <ReactTooltip
                id={"qr-" + h.subject.id}
                effect="solid"
                border={true}
                borderColor="#ccc"
                backgroundColor="white"
                arrowColor="white"
                className="clickable-tooltip"
                delayShow={300}
                delayHide={500}
                clickable
                isCapture
                globalEventOff="click"
              >
                <img
                  src={h.subject.qrcode_url}
                  alt=""
                  style={{ maxWidth: "300px", maxHeight: "300px" }}
                />
                <button
                  className="button-small"
                  style={{ width: "100%" }}
                  onClick={(e) => handlePrint("qr-" + h.subject.id)}
                >
                  {trans("buttons.print")}
                </button>
              </ReactTooltip>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}

export default Product
